import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    clientes: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',

    /* Listas de seleccion */
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_CLIENTES'(state) {
        state.clientes = [];
    },
    'SET_CLIENTES'(state, clientes) {
        state.clientes = clientes;
        state.totalRegistros = clientes.length;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(cliente => cliente.nombre.trim());
    },
};

const actions = {
    getClientes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CLIENTES')

            apiAxios.get('clientes')
                .then(res => {
                    commit('SET_CLIENTES', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST')

            apiAxios.get('clientes/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    clientes (state) {
        return state.clientes;
    },
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}